import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  SimpleChanges,
  OnChanges, OnDestroy,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { ListaDTO } from '../dtos/lista-DTO';
import { DataUsuario } from '../../../configuracion-cuenta/dto/data-usuarioDTO';
import { DatosAdicionalesAbogadoDTO } from '../dtos/datos-adicionales-abogado-DTO';
import { DatosAdicionalesService } from '../services/datos-adicionales.service';
import { FormField, FormFieldOption } from '../../../../dto/util/form-field';
import { Constants } from '../../../../constants/constants';
import { combineLatest, Subscription } from 'rxjs';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ModalSelectTipoUsuarioComponent } from '../../modal-select-tipo-usuario/modal-select-tipo-usuario.component';
import { UsuarioService } from '../../../../services/usuario.service';
import { UtilService } from '../../../../services/util.service';
import { LoginResponseDto } from '../../../../dto/auth/login-response.dto';
import { environment } from '../../../../../environments/environment';
import { FuncionalidadService } from '../../../../services/funcionalidad.service';
import { AutenticacionService } from '../../../auth/services/autenticacion.service';
import { NotificationService } from '../../../../services/notification.service';
import { ProcessService } from '../../../../services/process.service';
import { SocketService } from '../../../../services/socket.service';
import { UserDataDto } from '../../../../dto/auth/user-data.dto';
@Component({
  selector: 'app-modal-datos-adicionales-abogado',
  templateUrl: './modal-datos-adicionales-abogado.component.html',
  styleUrl: './modal-datos-adicionales-abogado.component.scss',
})
export class ModalDatosAdicionalesAbogadoComponent
  implements OnInit, OnChanges, OnDestroy {
  isSecure = environment.esHttps;

  @ViewChild('modalDatosAdicionalesAbogado')
  modalDatosAdicionalesAbogado!: ElementRef;
  @ViewChild(ModalSelectTipoUsuarioComponent)
  ModalTipoUsuarioComponent!: ModalSelectTipoUsuarioComponent;
  @Input() camposAbogado: string[] = [
    'graduacion',
    'universidad',
    'consultorioJuridico',
    'idConsultorioJuridico',
    'nivelEducativo',
  ];
  @Output() submitAction = new EventEmitter<FormGroup>();
  private langChangeSub!: Subscription;
  dataUsuario!: DataUsuario;

  ejerceAbogado: FormField[] = [];

  formEjerceAbogado!: FormGroup;

  flagMostrarFormulario: boolean = false;

  allFields: FormField[] = [];

  datosAbogado: DatosAdicionalesAbogadoDTO = {};

  // Multilenguaje
  modalText: any = {};
  comunText: any = {};
  // ruta
  ruta: string = '';
  loginResponse?: LoginResponseDto;

  openModalTipoUsuario = false;
  tiposUsuario: FormFieldOption[] = [];
  tipoUsuarioSeleccionado = 0;

  primerInicioSesion: boolean = false;
  @Input() openConfigCuenta: boolean = false;
  constructor(
    private readonly datosProvisionalesService: DatosAdicionalesService,
    private readonly alertService: AlertaModalService,
    private readonly translate: TranslateService,
    private readonly router: Router,
    private readonly usuarioService: UsuarioService,
    private utilService: UtilService,
    private funcionalidadService: FuncionalidadService,
    private authService: AutenticacionService,
    private notificationService: NotificationService,
    private processService: ProcessService,
    private socketService: SocketService
  ) {
    this.ruta = this.router.url;

  }

  ngOnInit() {
    const data = sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE);
    this.dataUsuario = data != null ? JSON.parse(data) : null;
    if (!this.openConfigCuenta) {
      this.obtenerDataUsuario();
    }
    combineLatest({
      modal: this.translate.stream('datos-adicionales'),
      comun: this.translate.stream('comun-label'),
    }).subscribe(({ modal, comun }) => {
      // Asignar traducciones a variables
      this.modalText = modal;
      this.comunText = comun;
      this.cargarFormulario();
    });
    this.getListaGraduacion();
    this.getNivelEducativo();
    this.getConsultorioJuridico();
    this.getDatosAdicionalesAbogado(this.dataUsuario.idPersona);

    this.langChangeSub = this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.getNivelEducativo();
      }
    );
  }

  obtenerDataUsuario() {
    const data = sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE);
    this.dataUsuario = data != null ? JSON.parse(data) : null;
    const dataAux = JSON.parse(data!);
    this.primerInicioSesion = dataAux.primerInicioSesion;
    this.consultarTiposUsuario(this.dataUsuario.idUsuario);
  }

  cargarFormulario() {

    this.ejerceAbogado = [
      {
        name: 'ejerceAbogado',
        label: this.modalText['seleccione-opcion'],
        type: 'radio',
        required: this.primerInicioSesion,
        width: '12',
        visible: this.primerInicioSesion,
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 0 },
        ],
        errorMessages: {
          required: this.modalText['ejerceAbogado-required'],
        },
      },
    ];

    this.allFields = [
      {
        name: 'universidad',
        label: this.modalText['universidad'],
        type: 'text',
        required: true,
        placeholder: this.modalText['universidad-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.maxLength(50),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.modalText['letras-pattern'],
          required: this.modalText['universidad-required'],
          maxlength: this.modalText['universidad-maxlength'],
        },
        value: this.datosAbogado.universidad,
      },
      {
        name: 'country',
        label: this.modalText['nacionalidad'],
        type: 'select',
        required: false,
        width: '12',
        visible: false,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          required: this.modalText['nacionalidad-required'],
        },
        value: 1,
      },
      {
        name: 'departament',
        label: this.modalText['departamento-ubicacion'],
        type: 'select',
        required: true,
        width: '12',
        visible: true,
        errorMessages: { required: this.modalText['departamento-required'] },
      },
      {
        name: 'municipality',
        label: this.modalText['municipio-ubicacion'],
        type: 'select',
        required: true,
        width: '12',
        visible: true,
        errorMessages: { required: this.modalText['municipio-required'] },
      },
      {
        name: 'graduacion',
        label: this.modalText['anio-graduacion'],
        type: 'select',
        required: true,
        multiple: false,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.modalText['anio-graduacion-required'] },
        value: this.datosAbogado.graduacion,
      },
      {
        name: 'tarjetaProfesional',
        label: this.comunText['tarjeta-profesional'],
        type: 'number',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.required,
          Validators.pattern(Constants.REGEX_WITHOUT_ESPACES),
          Validators.minLength(3),
          Validators.maxLength(12)
        ],
        errorMessages: {
          required: this.comunText['tarjeta-profesional-required'],
          minlength: this.comunText['tarjeta-profesional-minlength'],
          maxlength: this.comunText['tarjeta-profesional-maxlength'],
          pattern: this.comunText['tarjeta-profesional-pattern'],
        },
        value: this.datosAbogado.tarjetaProfesional
      },

      {
        name: 'consultorioJuridico',
        label: this.modalText['vinculacion'],
        type: 'radio',
        required: true,
        width: '12',
        visible: true,
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 0 },
        ],
        errorMessages: {
          required: this.modalText['vinculacion-required'],
        },
        value: this.datosAbogado.consultorioJuridico,
      },
      {
        name: 'idConsultorioJuridico',
        label: this.modalText['consultorio'],
        type: 'select',
        required: false,
        options: [],
        width: '12',
        visible: false,
        errorMessages: {
          required: this.modalText['consultorio-required'],
        },
        dependsOn: 'consultorioJuridico',
        visibilityCondition: value => value == 1,
        value: this.datosAbogado.idConsultorioJuridico,
      },
      {
        name: 'idNivelEducativo',
        type: 'select',
        label: this.modalText['nivel-educativo-rl'],
        required: true,
        placeholder: this.modalText['nivel-educativo-placeholder'],
        options: [],
        width: '12',
        visible: true,
        value: this.datosAbogado.idNivelEducativo,
        validation: [Validators.maxLength(20)],
        errorMessages: {
          pattern: this.modalText['letras-pattern'],
          required: this.modalText['nivel-educativo-placeholder'],
          maxlength: this.modalText['nivel-educativo-maxlength'],
        },
      },
    ];
  }


  /**
   * listas
   */

  getListaGraduacion() {
    this.datosProvisionalesService
      .getListaGraduacion()
      .subscribe((graduaciones: number[]) => {
        const listaGraduacion = graduaciones.map(grado => ({
          Id: grado,
          Nombre: '' + grado,
        }));
        this.allFields = this.allFields.map(field => {
          if (field.name == 'graduacion') {
            field.value =
              this.datosAbogado[field.name as keyof typeof this.datosAbogado];
            field.options = listaGraduacion;
          }
          return field;
        });
      });
  }

  getConsultorioJuridico() {
    this.datosProvisionalesService
      .getConsultoriosJuridicos()
      .subscribe((consultorios: ListaDTO[]) => {
        const listaConsultorios = consultorios.map(consultorio => ({
          Id: consultorio.Id,
          Nombre: consultorio.Valor,
        }));
        this.allFields = this.allFields.map(field => {
          if (field.name == 'idConsultorioJuridico') {
            field.value =
              this.datosAbogado[field.name as keyof typeof this.datosAbogado];
            field.options = listaConsultorios;
          }
          return field;
        });
      });
  }

  getNivelEducativo() {
    this.datosProvisionalesService
      .getNivelEducativo()
      .subscribe((nivelesEducativos: ListaDTO[]) => {
        const tiposNivelEducativo = nivelesEducativos
          .filter(nivel => !Constants.NIVELES_EDUCATIVOS_EXCLUIDOS.includes(nivel.Valor))
          .map(nivel => ({
            Id: nivel.Id,
            Nombre: ((this.translate.currentLang || this.translate.getDefaultLang()) === 'es') ? nivel.Valor : nivel.Valor_en,
          }));
        this.allFields = this.allFields.map(field => {
          if (field.name == 'idNivelEducativo') {
            field.value =
              this.datosAbogado[field.name as keyof typeof this.datosAbogado];
            field.options = tiposNivelEducativo;
          }
          return field;
        });
      });
  }

  obtenerTipoUsuario(tipoUsuarioSeleccionado: number) {
    if (!this.openConfigCuenta) {
      this.tipoUsuarioSeleccionado = tipoUsuarioSeleccionado;
      let selected = this.tiposUsuario.find(
        tipo => tipo.Id == tipoUsuarioSeleccionado
      );
      sessionStorage.setItem(Constants.USER_TYPE, JSON.stringify(selected));
      this.utilService.setRole(selected?.Nombre || null);
      this.consultarFuncionalidades();
      this.ModalTipoUsuarioComponent.abrirCerrarModal();
    }

  }

  consultarTiposUsuario(usuarioId?: number) {
    return this.usuarioService.consultarTiposUsuario(usuarioId!).subscribe({
      next: resp => {
        if (resp.tiposUsuario.length == 1) {
          this.tipoUsuarioSeleccionado = resp.tiposUsuario[0].Id;
          sessionStorage.setItem(
            Constants.USER_TYPE,
            JSON.stringify({
              Id: resp.tiposUsuario[0].Id,
              Nombre: resp.tiposUsuario[0].Tipo_Usuario,
              Id_Entidad: resp.tiposUsuario[0].Id_Entidad,
            })
          );
          this.utilService.setRole(resp.tiposUsuario[0].Tipo_Usuario || null);
          if (!this.openConfigCuenta) {
            this.consultarFuncionalidades();
          }
        } else {
          this.tiposUsuario = resp.tiposUsuario.map(tipo => {
            return {
              Id: tipo.Id,
              Nombre: tipo.Tipo_Usuario,
              Id_Entidad: tipo.Id_Entidad,
              selected: false,
            };
          });
        }
      },
    });
  }

  async consultarFuncionalidades() {
    let token;
    if (!this.isSecure) {
      token = this.loginResponse?.access_token;
    }
    return this.funcionalidadService
      .cargarFuncionalidadesPorTipoUsuario(this.tipoUsuarioSeleccionado, token)
      .subscribe({
        next: response => {
          sessionStorage.setItem(
            Constants.FUNCIONALIDADES,
            JSON.stringify(response)
          );
          this.tipoUsuarioSeleccionado === Constants.ID_TIPO_USUARIO_CIUDADANO || this.tipoUsuarioSeleccionado === Constants.ID_TIPO_USUARIO_ABOGADO ? this.router.navigateByUrl('procesos/resumen') : this.router.navigateByUrl(response[0]?.url || '/')
        },
      });
  }

  abrirModal() {
    this.modalDatosAdicionalesAbogado.nativeElement.click();
  }

  cerrarModal() {
    this.modalDatosAdicionalesAbogado.nativeElement.click();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['datosAbogado']) {
      this.datosAbogado = changes['datosAbogado']
        .currentValue as DatosAdicionalesAbogadoDTO;
    }
  }

  onSubmitEjerceAbogado($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formEjerceAbogado = $event.form ?? undefined;
    if ($event.controlName == Constants.EJERCE_ABOGADO) {
      if ($event.form.get(Constants.EJERCE_ABOGADO)?.value === Constants.TIPO_PERSONA.NATURAL) {
        this.flagMostrarFormulario = true;
      } else {
        this.flagMostrarFormulario = false;
      }
    }
  }

  onSubmit(form: FormGroup) {
    let json: DatosAdicionalesAbogadoDTO = {
      idPersona: this.dataUsuario.idPersona,
      graduacion: +form.get('graduacion')?.value,
      universidad: form.get('universidad')?.value,
      consultorioJuridico: form.get('consultorioJuridico')?.value === 1,
      idConsultorioJuridico: +form.get('idConsultorioJuridico')?.value,
      idMunicipioUniversidad: +form.get('municipality')?.value,
      idNivelEducativo: form.get('idNivelEducativo')?.value,
      tarjetaProfesional: form.get('tarjetaProfesional')?.value,
      idUsuario: this.dataUsuario.idUsuario
    };
    this.saveDatosAbogado(json);

    this.submitAction.emit(form);
  }

  saveDatosAbogado(json: DatosAdicionalesAbogadoDTO) {
    this.datosProvisionalesService
      .guardarDatosProvisionalesAbogado(json)
      .subscribe((response: any) => {
        if (response.success) {
          this.consultarTiposUsuario(this.dataUsuario.idUsuario);
          this.alertService.exito(this.modalText['save-datos']).then((result)=>{
            this.abrirModalTipoUsuario();
          });

          // if (this.ruta.split('/')[1].includes('expediente')) {
          //   this.datosProvisionalesService.activarGuia(true);
          // } else {
          //   this.datosProvisionalesService.activarGuia(false);
          // }
        } else {
          this.alertService.error(response.message);
        }
      });
  }

  abrirModalTipoUsuario() {
    if (!this.openConfigCuenta) {
      if (this.primerInicioSesion && this.tiposUsuario.length > 1) {
        this.openModalTipoUsuario = true;
        setTimeout(() => {
          this.ModalTipoUsuarioComponent.abrirCerrarModal();
        }, 500);
      }else{
        this.cerrarModal();
      }
    }
  }

  getDatosAdicionalesAbogado(idPersona: number) {
    this.datosProvisionalesService
      .getDataAbogado(idPersona)
      .subscribe((response: any) => {
        if (response.datoAdicionalAbogado) {
          this.datosAbogado = {
            idPersona: response.datoAdicionalAbogado.Id_Persona,
            graduacion: response.datoAdicionalAbogado.Graduacion,
            universidad: response.datoAdicionalAbogado.Universidad,
            consultorioJuridico: response.datoAdicionalAbogado
              .Consultorio_Juridico
              ? 1
              : 0,
            idConsultorioJuridico:
              response.datoAdicionalAbogado.Id_Consultorio_Juridico,
            idNivelEducativo: response.datoAdicionalAbogado.Id_Nivel_Educativo,
            country:
              response.datoAdicionalAbogado.Municipio_Universidad.Departamento
                .Id_Pais,
            departament:
              response.datoAdicionalAbogado.Municipio_Universidad
                .Id_Departamento,
            municipality:
              response.datoAdicionalAbogado.Municipio_Universidad.Id,
            tarjetaProfesional: response.datoAdicionalAbogado.Tarjeta_Profesional
          };
        }

        this.allFields = this.allFields.map(field => {
          if (
            this.datosAbogado[field.name as keyof typeof this.datosAbogado] !==
            undefined
          ) {
            field.value =
              this.datosAbogado[field.name as keyof typeof this.datosAbogado];
          }
          return field;
        });
        this.allFields.forEach(elemento => {
          if (elemento.name == 'consultorioJuridico') {
            if (elemento.value == 1) {
              this.setearObligatorioConsultorio(true);
            }
          }
        })
      });
  }

  onSubmitFormulario(form: FormGroup): void {
    this.submitAction.emit(form);
  }

  onSubmitAbogado($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    if ($event.controlName == 'consultorioJuridico') {
      if (formGroup.get('consultorioJuridico')?.value === 1) {
        formGroup
          .get('idConsultorioJuridico')
          ?.setValidators([Validators.required]);
        formGroup.get('idConsultorioJuridico')?.updateValueAndValidity();
        this.setearObligatorioConsultorio(true);
      } else {
        formGroup.get('idConsultorioJuridico')?.clearValidators();
        formGroup.get('idConsultorioJuridico')?.updateValueAndValidity();
        this.setearObligatorioConsultorio(false);
      }
    }
  }

  showGuia() {
    if (this.ruta.split('/')[1].includes('expediente')) {
      this.datosProvisionalesService.activarGuia(true);
    } else {
      this.datosProvisionalesService.activarGuia(false);
    }
  }

  setearObligatorioConsultorio(requerido: boolean) {
    this.allFields.forEach(elemento => {
      if (elemento.name == 'idConsultorioJuridico') {
        elemento.required = requerido;
      }
    })
  }

  ngOnDestroy() {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }
}
